<template>
  <div class="videoLearning">
    <div class="main-view-box">
      <div class="add-item" @click="initDialog();visible=true">
        <i class="el-icon-plus" />
        <p>添加视频</p>
      </div>
      <div v-for="item in dataList" :key="item.id" class="item">
        <div class="remove-box"><div><i class="el-icon-error" @click="deleteVideo(item)" /></div></div>
        <div class="content">
          <div class="video" @click="$emit('showDialog',item)">
            <div v-if="!item.frameUrl" class="video-player"></div>
            <img v-else :src="item.frameUrl" alt="">
            <i class="el-icon-video-play"></i>
          </div>
          <p class="title">{{item.name}}</p>
          <p class="time">{{item.createTime}}</p>
        </div>
      </div>
    </div>
    <el-dialog custom-class="dailogComponents" title="添加视频" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="500px">
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>视频名称:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.name" placeholder="请输入视频名称（1-20字段）"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>视频文件:</p>
          </el-col>
          <el-col :offset="1">
            <el-upload
                ref="uploadFile"
                drag
                :limit="1"
                :before-upload="beforeUpload"
                :on-success="uploadFile"
                action="/api/upload/uploadAndGetPng">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">请上传mp4格式视频，文件大小<500M</div>
            </el-upload>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button >
          <Debounce>
            <el-button size="medium" type="primary" @click="submit">确认</el-button>
          </Debounce>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "videoLearning",
  data(){
    return{
      dataList:[],
      visible: false,
      visibleType: 0, //0默认，1添加，2修改
      visibleObj: {
        name:'',
        url:'',
        type:0,
        frameUrl:'',
      },
    }
  },
  mounted() {
    this.getTableList()
  },
  methods:{
    initDialog(){
      this.visibleObj = {
        name:'',
        url:'',
        type:0,
        frameUrl:'',
      }
    },
    beforeUpload(file){
      console.log(file)
      let type = ['video/mp4','application/x-mpegURL']
      if(
          //含有固定的视频格式
          type.indexOf(file.type)!==-1 &&
          file.size<1024*1024*500
      ){
        return true
      }
      this.$message.warning('视频格式或大小不符，请检查后重新上传！')
      return false
    },
    uploadFile(res){
      console.log(res)
      let {data,msg,code} = res;
      if(code===10000){
        this.visibleObj.url = data.url;
        this.visibleObj.frameUrl = data.frameUrl;
      }else{
        this.$message.error(msg);
      }
    },
    submit(){
      if(!this.visibleObj.name || !this.visibleObj.url){
        this.$message.warning('请填写完整添加内容！');
        return
      }
      if(this.visibleObj.name.length>20){
        this.$message.warning('请按要求填写！');
        return;
      }
      this.$axios.post('/teachVideo',this.visibleObj).then(res=>{
        this.$message.success('添加成功！');
        this.visible = false;
        this.getTableList()
      })
    },
    deleteVideo(item){
      this.$dailog({
        title:'删除',
        context:'是否删除该视频？',
        callbackFun:()=>{
          this.$axios.delete('/teachVideo?id='+item.id).then(res=>{
            this.$message.success('删除成功！');
            this.getTableList()
          })
        }
      })
    },
    getTableList(){
      this.$axios.post('/teachVideo/list?type=0').then(res=>{
        this.dataList = res.data.data;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main-view-box{
  height: calc(100% - 90px);
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  .add-item,.item{
    width: 360px;
    height: 300px;
    margin: 10px;
  }
  .add-item{
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    p{
      color: #bfbfbf;
      font-size: 24px;
    }
    i{
      color: #bfbfbf;
      font-weight: bold;
      font-size: 120px;
    }
  }
  .item{
    box-shadow: 0 1px 6px #d2d2d2;
    border-color: #eee;
    overflow: hidden;

    .content{
      overflow: hidden;
      padding: 20px 10px;
      display: flex;
      flex-direction: column;
      height: calc(100% - 40px);
      .title{
        font-size: 18px;
        display: flex;
        margin: 10px 0;
        font-weight: bold;
      }
      .time{
        font-size: 13px;
      }
      .video{
        flex: 1;
        position: relative;
        overflow: hidden;
        height: calc(100% - 40px);
        .video-player{
          position: relative;
          height: 100%;
          background-color: #333333;
          cursor: pointer;
        }
        img{
          position: relative;
          height: 100%;
          width: 100%;
          cursor: pointer;
        }
        .el-icon-video-play{
          z-index: 2;
          position: absolute;
          cursor: pointer;
          color: white;
          top: 25%;
          font-size: 100px;
          left: calc(50% - 50px);
        }
      }
    }
    .button{
      height: 16%;
      display: flex;
      .el-button{
        flex: 1;
        margin: 0 !important;
        border-radius: 0;
      }
    }
    .remove-box{
      position: relative;
      >div{
        position: absolute;
        cursor: pointer;
        z-index: 3;
        right: -80px;
        top: -80px;
        width: 80px;
        height: 80px;
        color: white;
        transform: rotateZ(45deg);
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        transition: all 0.2s 0s linear;
        >i{
          transform: rotateZ(-45deg);
          margin-bottom: 5px;
          font-size: 28px;
          color: #ff5353;
        }
      }
    }
  }
  .item:hover{
    .remove-box{
      >div{
        right: -40px;
        top: -40px;
      }
    }
  }
}
</style>
